import { Component } from "@wonderlandengine/api";

export class GlobalGravityComponent extends Component {
    static TypeName = "pp-global-gravity";
    static Properties = {};

    init() {
    }
}